import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { removeSerialNumberPrefix } from '../../../utils/string-utility';
import { DocsDataAPI } from '../API/DocsDataAPI';
import useAPIError from "../APIError";
import Utils from "../Utils";
import { useStyles } from "./AssetNonTitled/AssetNonTitledFormStyles";
import useAssetProvider from "./useAssetProvider";
import useStyle3 from "./UseStyles";

const useStyles2 = makeStyles({
	box: {
		padding: ".5rem .5rem .25rem .5rem",
	},
});

const ltvColor = {
	style: { color: 'rgb(50, 50, 50)' }
}

const SellingDetails = ({ details, notSupported, checkAssestEditAccess }) => {
	const classes = useStyles();
	const classes2 = useStyles2();
	const classes3 = useStyle3();
	const { addError } = useAPIError();
	const componentRef = useRef();
	const [open, setOpen] = useState(false);
	const handleClose = () => {
		setOpen(false);
	};
	const {
		app,
		isReadOnly,
		assetDocuments,
		assetTypes,
		onAssetUpdate,
		getAttachment,
	} = useAssetProvider();
	const [selectedGroup, setSelectedGroup] = useState("");
	const [assetGroups, setAssetGroups] = useState([]);
	const [selectedSubGroup, setSelectedSubGroup] = useState("");
	const [assetSubGroups, setAssetSubGroups] = useState([]);
	const [assetType, setAssetType] = useState("");
	const [filteredAssetTypes, setFilteredAssetTypes] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [constructionType, setConstructionType] = useState("");
	const [assetManagerNotes, setAssetManagerNotes] = useState("");
	const [valuation, setValuation] = useState(0);
	const [brokerValuation, setBrokerValuation] = useState(0);
	const [price, setPrice] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [
		is_nonconforming_evidence_provided,
		setIs_nonconforming_evidence_provided,
	] = useState(false);
	const [isDownloading, setIsDownloading] = useState(false);
	const [showWarning, setShowWarning] = useState(false);
	const [attachment, setAttachment] = useState({});
	const [attachState, setAttachState] = useState("Attach");
	const [attachCount, setAttachCount] = useState(0);
	const [selectedAttachment, setSelectedAttachment] = useState("");
	const [titleProcessed, setTitleProcessed] = useState("");
	const [titleReassignment, setTitleReassignment] = useState("");
	const [titleStatus, setTitleStatus] = useState("");
	const [titleProcessedByList, setTitleProcessedByList] = useState([]);
	const [titleStatusList, setTitleStatusList] = useState([]);
	const [assetTypeValue, setAssetTypeValue] = useState("");

	useEffect(() => {
		(async () => {
			try {
				setAttachment({});
				setAssetTypeValue(details.type || "");
				setSelectedGroup(details.override_asset_type_group || "");
				setSelectedSubGroup(details.override_asset_type_subgroup || "");
				setIs_nonconforming_evidence_provided(
					details.is_nonconforming_evidence_provided || false
				);
				setAssetType(details.override_asset_type || "");
				setConstructionType(details.construction_equipment_type || "");
				setValuation(details.asset_value_override || 0);
				setBrokerValuation(details.broker_valuation || 0);
				setAssetManagerNotes(details.asset_manager_notes || "");
				setTitleReassignment(details.title_reassignment_needed || "");
				setTitleStatus(details.title_status || "");
				setTitleProcessed(details.title_processed_by || "");
				setPrice(Number(details.price)?.toFixed(2) || 0);
				// const mappedAssetTypes = assetTypes?.map((item) => {
				// 	return {
				// 		label: item,
				// 	};
				// });
				// let sortedAssetTypes = mappedAssetTypes.sort((a, b) => Utils.compare(a, b));
				// let assetGroupSet = new Set(
				// 	assetTypes.map((item) => item.asset_type_group)
				// );
				setAssetGroups(
					[...new Set(assetTypes.map((item) => item.asset_type_group))].sort()
				);
				setAssetSubGroups(
					[...new Set(assetTypes.map((item) => item.asset_type_subgroup))].sort()
				);
				const filteredData = assetTypes?.filter(
					(item) =>
						removeSerialNumberPrefix(item.asset_type_group) === removeSerialNumberPrefix(details.override_asset_type_group || "") &&
						removeSerialNumberPrefix(item.asset_type_subgroup) === removeSerialNumberPrefix(details.override_asset_type_subgroup || "")
				);
				const sortedFilteredAssetTypes = filteredData?.sort((a, b) =>
					a.description > b.description ? 1 : -1
				);
				setFilteredAssetTypes(sortedFilteredAssetTypes);
				// setFilteredAssetTypes(
				// 	assetTypes
				// 		.filter(
				// 			(item) =>
				// 				item.asset_type_subgroup === details.override_asset_type_subgroup
				// 		)
				// 		?.sort((a, b) => (a.description > b.description ? 1 : -1))
				// );
				const docList = assetDocuments?.filter((x) => x.asset === details.id && !x.is_archived);
				if (docList) {
					setDocuments(docList);
					setAttachCount(
						assetDocuments?.filter((x) => x.asset === details.id && !x.is_archived)?.length
					);
				} else setDocuments([]);
			} catch (error) {
				console.log(error.message);
			}
		})();
	}, [details, assetDocuments, addError]);

	useEffect(() => {
		(async () => {
			const dropdownList = [];
			await DocsDataAPI.getTitleProcessedByList().then((resp) =>
				resp.map((titleProcessedBy) => {
					dropdownList.push(titleProcessedBy);
				})
			);
			setTitleProcessedByList(dropdownList);
		})();
		(async () => {
			const dropdownList = [];
			await DocsDataAPI.getTitleStatusList().then((resp) =>
				resp.map((titleStatusList) => {
					dropdownList.push(titleStatusList);
				})
			);
			setTitleStatusList(dropdownList);
		})();
	}, []);

	const isSavingDisabled = () => {
		if (isReadOnly || showWarning || notSupported) return true;
		if (isSystemMatch()) return true;
		// if (!details.year && !details.make && !details.model) return true;

		return false;
	};

	const isSystemMatch = () => {
		return (
			details.asset_value_override === details.adjusted_derived_cost_wholesale
		);
	};

	const fileAttachmentHandler = async (e) => {
		if (e.target.value.length > 0) {
			setAttachState("Attached");
			let file = e.target.files[0];
			let fileData = await Utils.readFile(file);
			// console.log("Access", fileData);
			// setAttachment({
			// 	base_file: fileData.data,
			// 	content_type: fileData.mimeType,
			// 	type: "Asset - Evidence",
			// 	document_name: file.name,
			// 	asset: details.id,
			// 	application_id: details.application_id,
			// });
			setAttachment(file);
		} else {
			setAttachState("Attach");
			setAttachment({});
			e.target.value = null;
		}
	};

	// const downloadAttachment = async (documentId) => {
	// 	try {
	// 		setSelectedAttachment(documentId);
	// 		setIsDownloading(true);
	// 		let docs = await getAttachmentInfo(documentId);
	// 		docs && (await downloadFile(docs));
	// 	} catch (error) {
	// 		// console.log(error.message);
	// 		setIsDownloading(false);
	// 	} finally {
	// 		setIsDownloading(false);
	// 		setSelectedAttachment("");
	// 	}
	// };

	const downloadAFile = async (documentId, azure_file_url, document_name) => {
		try {
			setSelectedAttachment(documentId);
			setIsDownloading(true);
			let file_storage_Url = "";
			const containerType = "applications";
			// New method to download the files from Azure File Store
			if (azure_file_url !== undefined) {
				file_storage_Url = await DocsDataAPI.getFileStoreURL(
					azure_file_url,
					containerType
				);
				let link = Utils.urlDownloadfromLink(file_storage_Url, document_name);
				link.click();
				window.URL.revokeObjectURL(link.href);
			} else {
				// Previous method to download the file from Saleforce
				let attachments = await DocsDataAPI.getDocumentAttachment(documentId);
				if (attachments.length > 0) {
					let blob = Utils.base64ToBlob(
						attachments[0].body,
						attachments[0].content_type
					);
					let link = Utils.blobToLink(blob, attachments[0].name);
					link.click();
					window.URL.revokeObjectURL(link.href);
				}
			}
		} catch (e) {
			console.log(e);
			alert("Failed to download file");
		} finally {
			setIsDownloading(false);
			setSelectedAttachment("");
		}
	};
	const viewAttachment = async (row) => {
		try {
			setIsLoading(true);
			setSelectedAttachment(row.id);
			let docs = await getAttachment(row.id);
			if (docs[0].content_type) {
				let pdfWindow = window.open(row.document_name);
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:" +
					docs[0].content_type +
					";base64, " +
					encodeURI(docs[0].body) +
					"'></iframe>"
				);
			} else {
				const type = row.document_name?.split(".");
				if (type[1] === "PNG") {
					let pdfWindow = window.open(row.document_name);
					pdfWindow.document.write(
						"<iframe width='100%' height='100%' src='data:" +
						"image/png;base64" +
						";base64, " +
						encodeURI(docs[0].body) +
						"'></iframe>"
					);
				}
				// await downloadFile(docs);
			}
		} catch (e) {
			console.log(e.message);
		} finally {
			setIsLoading(false);
			setSelectedAttachment("");
		}
	};

	// const downloadFile = async (attachments) => {
	// 	try {
	// 		if (attachments.length > 0) {
	// 			let fileType = attachments[0].name.split(".");
	// 			let blob = Utils.base64ToBlob(attachments[0].body, fileType);
	// 			let link = Utils.blobToLink(blob, attachments[0].name);
	// 			link.click();
	// 			window.URL.revokeObjectURL(link.href);
	// 		}
	// 	} catch (e) {
	// 		console.log(e);
	// 	}
	// };

	const getAttachmentInfo = async (documentId) => {
		try {
			let Attachment = await getAttachment(documentId);
			return Attachment;
		} catch (error) {
			console.log(error.message);
		}
	};

	const handleAssetGroup = async (event) => {
		setSelectedGroup(event.target.value);
		setSelectedSubGroup("");
		setAssetType("");
		setFilteredAssetTypes([]);

		const assetSubgroup = assetTypes.filter(
			(item) => removeSerialNumberPrefix(item.asset_type_group) === removeSerialNumberPrefix(event.target.value)
		);
		const newSubGroup = [
			...new Set(assetSubgroup.map((item) => item.asset_type_subgroup)),
		].sort();

		setAssetSubGroups(
			newSubGroup[0] !== undefined && newSubGroup?.length > 0 ? newSubGroup : []
		);
		await filterAssetTypesBySubGroup(assetTypeValue);
	};

	const handleAssetSubGroup = async (event) => {
		setSelectedSubGroup(event.target.value);
		const filteredData = assetTypes?.filter(
			(item) =>
				removeSerialNumberPrefix(item.asset_type_group) === removeSerialNumberPrefix(selectedGroup) &&
				removeSerialNumberPrefix(item.asset_type_subgroup) === removeSerialNumberPrefix(event.target.value)
		);
		const sortedFilteredAssetTypes = filteredData?.sort((a, b) =>
			a.description > b.description ? 1 : -1
		);
		setFilteredAssetTypes(sortedFilteredAssetTypes);
	};

	const filterAssetTypesBySubGroup = async (assetType) => {
		setShowWarning(false);
		const normalizedAssetType = removeSerialNumberPrefix(assetType);
		if (
			details?.type !== "Non-Titled" &&
			(normalizedAssetType == "Forestry" ||
				normalizedAssetType == "Construction" ||
				normalizedAssetType == "Agricultural" ||
				normalizedAssetType == "Medical" ||
				normalizedAssetType == "Manufacturing" ||
				normalizedAssetType == "Printing" ||
				normalizedAssetType == "Other" ||
				normalizedAssetType == "Machine Tool")
		) {
			setShowWarning(true);
		} else if (
			details?.Type__c == "Non-Titled" &&
			(normalizedAssetType == "Trailer" ||
				normalizedAssetType == "Other Transportation" ||
				normalizedAssetType == "Vocational Transportation" ||
				normalizedAssetType == "Class 8 Transportation")
		) {
			setShowWarning(true);
		}
	};

	const ltvPercentage = () => {
		return parseFloat(details?.price) === 0
			? 100
			: (parseFloat(valuation || 0) / parseFloat(details?.price || 0)) * 100;
	};

	const updateAsset = () => {
		if (ltvPercentage() > 100) {
			addError("Advised price shouldn't be more than selling price!");
		} else {
			const updatedAssetData = {
				...details,
				type: assetTypeValue,
				override_asset_type_group: selectedGroup,
				override_asset_type_subgroup: selectedSubGroup,
				override_asset_type: assetType,
				construction_equipment_type: constructionType,
				asset_manager_notes: assetManagerNotes,
				asset_value_override: valuation,
				broker_valuation: brokerValuation,
				price: price,
				is_nonconforming_evidence_provided: is_nonconforming_evidence_provided,
				title_reassignment_needed: titleReassignment,
				title_status: titleStatus,
				title_processed_by: titleProcessed,
			};
			delete updatedAssetData.override_asset_type_gps_fee;
			onAssetUpdate(updatedAssetData, attachment);
		}
	};

	return (
		<>
			<Box className={classes.boxDesign}>
				<Box className={classes2.box} hidden={!showWarning}>
					<Alert severity="error" align="left">
						Asset Type & Asset group mismatched!
					</Alert>
				</Box>
				<Box className={classes2.box}>
					<FormControl
						style={{
							width: "100%",
						}}>
						<InputLabel id="assetTypeSelect">Asset Type</InputLabel>
						<Select
							labelId="assetTypeSelect"
							label="Asset Type"
							value={assetTypeValue || ""}
							disabled={isReadOnly || notSupported}
							onChange={(e) => {
								setAssetTypeValue(e.target.value);
							}}
							style={{ textAlign: "left" }}>
							<MenuItem key="Truck - Chassis Only" value="Truck - Chassis Only">
								Truck
							</MenuItem>
							<MenuItem value="Truck with Body">Truck with Body</MenuItem>
							<MenuItem value="Trailer">Trailer</MenuItem>
							<MenuItem value="Non-Titled">Non-Titled</MenuItem>
						</Select>
					</FormControl>
				</Box>
				<Box className={classes2.box}>
					<FormControl
						style={{
							width: "100%",
						}}>
						<InputLabel id="selectedGroup">Spoke</InputLabel>
						<Select
							labelId="selectedGroup"
							label="Asset Type"
							value={selectedGroup || ""}
							disabled={isReadOnly || notSupported}
							onChange={(e) => handleAssetGroup(e)}
							style={{ textAlign: "left" }}>
							{assetGroups.map((item, index) => (
								<MenuItem key={index} value={item}>
									{removeSerialNumberPrefix(item)}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>

				<Box className={classes2.box}>
					<FormControl
						style={{
							width: "100%",
						}}>
						<InputLabel id="assetSubGroup">Group</InputLabel>
						<Select
							labelId="assetSubGroup"
							label="Asset Type Sub Group"
							value={selectedSubGroup || ""}
							disabled={isReadOnly || notSupported}
							onChange={(e) => handleAssetSubGroup(e)}
							style={{ textAlign: "left" }}>
							{assetSubGroups.map((item, index) => (
								<MenuItem key={index} value={item}>
									{item}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>

				<Box className={classes2.box}>
					<FormControl
						style={{
							width: "100%",
						}}>
						<InputLabel id="assetType">Equipment Type</InputLabel>
						<Select
							labelId="assetType"
							label="Asset Type"
							value={assetType || ""}
							disabled={isReadOnly || notSupported}
							onChange={(e) => {
								setAssetType(e.target.value);
							}}
							style={{ textAlign: "left" }}>
							{filteredAssetTypes.map((assetType, index) => (
								<MenuItem key={index} value={assetType.name}>
									{assetType.description}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>

				<Box className={classes2.box}>
					{removeSerialNumberPrefix(selectedGroup) === "Agricultural" ||
						removeSerialNumberPrefix(selectedGroup) === "Forestry" ? (
						<FormControl
							style={{
								width: "100%",
							}}>
							<InputLabel id="selectType">Select Type</InputLabel>
							<Select
								labelId="selectType"
								value={constructionType}
								disabled={isReadOnly || notSupported}
								onChange={(e) => {
									setConstructionType(e.target.value);
								}}
								style={{ textAlign: "left" }}>
								<MenuItem value="heavy">Heavy</MenuItem>
								<MenuItem value="light">Light</MenuItem>
							</Select>
						</FormControl>
					) : (
						<></>
					)}
				</Box>

				<Box className={classes2.box}>
					<TextField
						id="salePrice"
						style={{
							width: "100%",
						}}
						label="Sale Price"
						value={price}
						InputProps={{
							startAdornment: <InputAdornment position="start">$</InputAdornment>,
							maxLength: 15,
							step: "1",
							pattern: "[0-9]*",
						}}
						onChange={(e) => {
							setPrice(e.target.value.toLocaleString('en-US', { maximumFractionDigits: 2 }))
						}}
					/>
				</Box>

				<Box className={[classes2.box, classes.headers]} >
					<TextField
						error={ltvPercentage() > 100}
						helperText={
							ltvPercentage() > 100
								? "Advised price shouldn't be more than selling price!"
								: ""
						}
						id="valuation"
						label="Valuation"
						style={{
							width: "60%",
						}}
						value={valuation}
						InputProps={{
							startAdornment: <InputAdornment position="start">$</InputAdornment>,
						}}
						onChange={(e) => {
							setValuation(e.target.value);
						}}
						disabled={isReadOnly || notSupported}
					/>
					<TextField
						id="ltv"
						label="LTV"
						style={{
							width: "40%",
							color: "red"
						}}
						inputProps={ltvColor}
						defaultValue={Utils.formatCurrencyNumber(details?.ltv)}
						value={Utils.formatCurrencyNumber(details?.ltv) + ` %`}
						disabled={true}
					/>
				</Box>
				<Box className={classes2.box}>
					<TextField
						error={ltvPercentage() > 100}
						id="brokervaluation"
						label="Broker Valuation"
						style={{
							width: "100%",
						}}
						value={brokerValuation}
						InputProps={{
							startAdornment: <InputAdornment position="start">$</InputAdornment>,
						}}
						onChange={(e) => {
							setBrokerValuation(e.target.value);
						}}
						disabled={isReadOnly || notSupported}
					/>
				</Box>

				{
					app && (app?.status === 'Document Check In' || app?.status === 'Funding')
					&&
					<>

						<Box className={classes2.box}>
							<FormControl
								style={{
									width: "100%",
								}}>
								<InputLabel id="selectType">Title Processed By</InputLabel>
								<Select
									labelId="selectType"
									value={titleProcessed}
									disabled={isReadOnly}
									onChange={(e) => {
										setTitleProcessed(e.target.value);
									}}
									style={{ textAlign: "left" }}>
										{titleProcessedByList.map((item, index) => (
											<MenuItem key={index} value={item}>
												{item}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						</Box>
						<Box className={classes2.box}>
							<FormControl
								style={{
									width: "100%",
								}}>
								<InputLabel id="selectType">Title Status</InputLabel>
								<Select
									labelId="selectType"
									value={titleStatus}
									disabled={isReadOnly}
									onChange={(e) => {
										setTitleStatus(e.target.value);
									}}
									style={{ textAlign: "left" }}>
										{titleStatusList.map((item,index) => (
											<MenuItem key={index} value={item}>
												{item}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						</Box>
						<Box className={classes2.box}>
							<FormControl
								style={{
									width: "100%",
								}}>
								<InputLabel id="selectType">Title Reassignment Needed</InputLabel>
								<Select
									labelId="selectType"
									value={titleReassignment}
									disabled={isReadOnly}
									onChange={(e) => {
										setTitleReassignment(e.target.value);
									}}
									style={{ textAlign: "left" }}>
									<MenuItem value="Yes">Yes</MenuItem>
									<MenuItem value="No">No</MenuItem>
								</Select>
							</FormControl>
						</Box>
					</>
				}

				<Box className={classes2.box}>
					<TextField
						fullWidth={true}
						rows={3}
						style={{
							width: "100%",
						}}
						id="assetNotes"
						label="Asset Notes"
						placeholder="Asset Notes"
						value={assetManagerNotes || ""}
						multiline
						onChange={(e) => {
							setAssetManagerNotes(e.target.value);
						}}
						disabled={isReadOnly || notSupported}
					/>
				</Box>

				<Box className={classes2.box}>
					<div className={classes.verticalGap}>
						<input
							disabled={isReadOnly || notSupported}
							className={classes.input}
							id="buttonFile"
							type="file"
							onChange={fileAttachmentHandler}
						/>
						<div>
							<label htmlFor="buttonFile">
								<Button
									disabled={isReadOnly || notSupported}
									style={{ backgroundColor: "#CF7200", color: "white" }}
									color="primary"
									component="span">
									{attachState}
								</Button>
							</label>
							<Button
								disabled={isReadOnly || notSupported}
								style={{ backgroundColor: "#CF7200", color: "white" }}
								className={classes.horizontalGap}
								startIcon={
									isLoading && <CircularProgress style={{ color: "white" }} size={20} />
								}
								color="primary"
								onClick={() => setOpen(true)}
								component="span">
								{attachCount}
							</Button>
						</div>
					</div>
				</Box>

				<Box className={classes2.box}>
					<FormControlLabel
						hidden={isSystemMatch()}
						disabled={isReadOnly || notSupported}
						align="left"
						className={classes.verticalGap}
						checked={is_nonconforming_evidence_provided || false}
						onChange={(e) => {
							setIs_nonconforming_evidence_provided(e.target.checked);
						}}
						control={<Checkbox color="primary" name="confirmation" />}
						label="I have attached the evidence/notes required to support my valuation of this asset."
					/>

					<div className={classes.verticalGap}>
						<Button
							disabled={isSavingDisabled()}
							fullWidth={true}
							className={
								!isSavingDisabled() ? classes3.saveButton : classes3.saveButtonDisalbe
							}
							// style={{ backgroundColor: "#022F40", color: "white" }}
							onClick={updateAsset}>
							Save
						</Button>
					</div>
				</Box>
			</Box>
			<Dialog
				fullWidth
				maxWidth="md"
				className={classes3.modalDimensions}
				open={open}
				onClose={() => handleClose}>
				<DialogTitle id="customized-dialog-title" className={classes3.modalHeader}>
					<Grid
						container
						className={classes3.header}
						direction="row"
						justify="space-between"
						displayPrint="none">
						<Grid item sm={8}>
							Documents
						</Grid>
						<Grid item sm={4} align="right">
							<Button
								variant="contained"
								color="secondary"
								size="small"
								className={classes3.closeButton}
								startIcon={<CloseIcon />}
								onClick={handleClose}>
								Close
							</Button>
						</Grid>
					</Grid>
				</DialogTitle>

				<DialogContent dividers>
					<Grid
						container
						direction="row"
						ref={componentRef}
						className="print-container">
						<Grid item sm={12} className={classes3.grid_space_modal} xs={12}>
							{attachCount > 0 ? (
								<TableContainer>
									<Table className={classes3.reportTable} aria-label="simple table">
										<TableHead>
											<TableRow>
												<TableCell align="left">Document Name</TableCell>
												<TableCell align="left">Document Type</TableCell>
												<TableCell align="left">Document Upload Date</TableCell>
												<TableCell align="center">Actions</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{documents?.map((item, i) => (
												<TableRow key={i}>
													<TableCell align="left">{item.document_name}</TableCell>
													<TableCell align="left">{item.type}</TableCell>
													<TableCell align="left">
														{moment(item.date_uploaded).format("MM-DD-YYYY hh:mm:ss")}
													</TableCell>
													<TableCell align="center">
														{/* <Button
															size="small"
															className={classes3.button}
															variant="contained"
															color="primary"
															startIcon={
																isLoading && selectedAttachment === item.id ? (
																	<CircularProgress size={20} style={{ color: "white" }} />
																) : (
																	<PrintIcon />
																)
															}
															onClick={() => viewAttachment(item)}>
															View
														</Button>
														&nbsp; */}
														<Button
															size="small"
															className={classes3.button}
															color="primary"
															startIcon={
																isDownloading && selectedAttachment === item.id ? (
																	<CircularProgress size={20} style={{ color: "white" }} />
																) : (
																	<GetAppIcon />
																)
															}
															onClick={() => downloadAFile(
																item.id,
																item?.azure_file_url,
																item?.document_name
															)}
															variant="contained">
															Download
														</Button>
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							) : (
								<span>For this asset Documents not available</span>
							)}
						</Grid>
						<Grid
							className={classes3.grid_space_modal}
							align="right"
							item
							sm={12}
							xm={12}></Grid>
					</Grid>
				</DialogContent>
			</Dialog>
		</>
	);
};
export default SellingDetails;
